export default __webpack_public_path__ + "static/media/error403.662710c0.svg";